const PrivacyPolicy = () => {
	return (
		<>
			<section className="contact py-80">
				<div className="container container-lg">
					<div className="row gy-5">
						<div className="col-lg-12">
							<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
								<h4 className="text-bold headingsize ">
									Privacy <span className="primecolor">Policy</span>
								</h4>

								<ul className="mt-32">
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Udemandme.com’s policy and system are designed to protect
											any information given by the customer when using this
											website. We are committed to ensuring that all customer
											information is protected. Any information required and
											filled in by the customer is stored and well protected in
											accordance with our privacy statement. Our Privacy Policy
											may change from time to time to ensure better security and
											customer satisfaction. We request all customers to review
											our privacy policy periodically. We are also open to
											suggestions. The aim is to keep our customer base strong
											and to create a family-like experience.
										</span>
									</li>
									<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24">
										We collect customer information such as detailed addresses
										and other relevant details in order to:
									</h6>

									<ul className="mt-32">
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Deliver products to customers
												<span className="text-gray-500">
													<span className="text-gray-500 px-1"></span>{" "}
												</span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Maintain a customer database
												<span className="text-gray-500 px-1"></span>
											</span>
										</li>
										<li className="d-flex align-items-start gap-8 mb-20">
											<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
												<i className="ph ph-check icon-s"></i>
											</span>
											<span className="text-heading fw-medium">
												Notify them of new offers and price changes With the
												information provided by the customer, we aim to improve
												our services.
												<span className="text-gray-500 px-1"></span>
											</span>
										</li>
									</ul>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											VAT invoices will be provided to customers so they can
											claim VAT benefits.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Data security and payments are handled through highly
											secure methods. An industry-best payment gateway is used
											for these services, ensuring the client's benefit.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Any information regarding card purchases on our website
											will not be stored, shared, rented, or sold to any third
											party.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											For convenience and additional information, Udemandme.com
											may contain links to other websites or YouTube links.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 mx-5 px-5">
										<span className="text-md text-gray-900 ">
											However, Udemandme.com does not take responsibility for
											the protection and privacy of information when visiting
											such links. These links are not governed by our privacy
											policy. We only include external links after confirmation
											from authorized sources, but we cannot guarantee
											responsibility for their content.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											For any corrections or updates to the information provided
											by the customer, please use the contact form on our
											website or WhatsApp us. Be sure to include your registered
											email and mobile number. Our primary communication will be
											through WhatsApp, where we will keep you informed and
											regularly updated about our website.
										</span>
									</li>
								</ul>
								<div>
									<h6 className="mt-24">
										INFORMATION GATHERED BY{" "}
										<span className="primecolor">Udemandme.com</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900 ">
												This is Al Sukoon General Trading Co. LLC’s
												(“Udemandme.com”) online privacy policy (“Policy”). This
												policy applies only to activities Udemandme.com engages
												in on its website and does not apply to activities that
												are offline or unrelated to the website.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900 ">
												This is Al Sukoon General Trading Co. LLC’s
												(“Udemandme.com”) online privacy policy (“Policy”). This
												policy applies only to activities Udemandme.com engages
												in on its website and does not apply to activities that
												are offline or unrelated to the website.
											</span>
										</li>
										<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24">
											Anonymous data may include:
										</h6>

										<ul className="mt-32">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Type of browser used
													<span className="text-gray-500">
														<span className="text-gray-500 px-1"></span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Duration of website visit
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
										</ul>
										<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24">
											You may also be asked to provide personally identifiable
											information (such as your name, address, phone number, and
											email address) when:
										</h6>

										<ul className="mt-32">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Sending feedback or emails
													<span className="text-gray-500">
														<span className="text-gray-500 px-1"></span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Registering for services
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Making purchases on the website Providing this
													information is optional.
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
										</ul>
									</ul>
								</div>
								<div>
									<h6 className="mt-24">
										USE AND DISCLOSURE OF{" "}
										<span className="primecolor">INFORMATION</span>
									</h6>
									<ul className="mt-32">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900 ">
												Except where stated below, we do not sell, trade, or
												rent your personally identifiable information collected
												on the site.
											</span>
										</li>

										<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24">
											Information collected is used to:
										</h6>

										<ul className="mt-32">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Process orders
													<span className="text-gray-500">
														<span className="text-gray-500 px-1"></span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Keep you updated about your order status
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Notify you of new products or offers
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Improve our site through statistical analysis
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
										</ul>
										<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24">
											We may share your delivery information with third parties
											only for:
										</h6>

										<ul className="mt-32">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Order tracking
													<span className="text-gray-500">
														<span className="text-gray-500 px-1"></span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Processing checks or money orders
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Fulfilling orders
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Performing statistical analysis
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Delivering promotional emails
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
										</ul>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900 ">
												For example, your mailing address will be shared with
												the delivery service to deliver your order.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14 mx-5 px-5 f-bold">
											<span className="text-md text-gray-900 ">
												All credit/debit card details and personally
												identifiable information will NOT be stored, sold,
												shared, rented, or leased to any third parties.
											</span>
										</li>
									</ul>
								</div>
								<div>
									<h6 className="mt-10">
										COOKIES <span className="primecolor"></span>
									</h6>
									<ul className="mt-10">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900 ">
												ookies are small pieces of data cached in the user's
												browser. Udemandme.com uses cookies only to determine if
												you’ve previously visited the homepage. No personal data
												is collected via cookies.
											</span>
										</li>

										<h6 className="title text-lg fw-semibold mt-12  mt-24">
											We may also use non-personal aggregated data to:
										</h6>

										<ul className="mt-24">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Enhance website operations
													<span className="text-gray-500">
														<span className="text-gray-500 px-1"></span>{" "}
													</span>
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													Analyze interest in website sections
													<span className="text-gray-500 px-1"></span>
												</span>
											</li>
										</ul>

										<li className="text-gray-400 mb-14 flex-align gap-14 mx-5 px-5 f-bold">
											<span className="text-md text-gray-900 ">
												If you submit content or feedback for publishing, we may
												use your username or identifying data with your
												permission.
											</span>
										</li>
									</ul>
								</div>
								<div>
									<h6 className="mt-24">
										DISCLOSURE DUE TO{" "}
										<span className="primecolor">LEGAL REQUIREMENTS</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												We may disclose personally identifiable information:
											</span>
										</li>

										<ul className="mt-20">
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													In response to a subpoena or court order
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													As required by law or to comply with law enforcement
													requests
												</span>
											</li>
											<li className="d-flex align-items-start gap-8 mb-20">
												<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
													<i className="ph ph-check icon-s"></i>
												</span>
												<span className="text-heading fw-medium">
													If Udemandme.com is involved in bankruptcy or asset
													transfer due to a merger or acquisition
												</span>
											</li>
										</ul>
									</ul>

									<h6 className="mt-24">
										DATA <span className="primecolor">SECURITY</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												Udemandme.com uses both hardware and software
												protections to secure your data. However, no method of
												transmission over the Internet is 100% secure.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												We cannot guarantee complete security of information
												disclosed online.
											</span>
										</li>
									</ul>

									<h6 className="mt-24">
										OTHER <span className="primecolor">WEBSITES</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												Udemandme.com is not responsible for privacy practices
												of third-party websites linked from ours.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												These sites may send their own cookies, collect data, or
												solicit personal information.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												We recommend reviewing their privacy policies before
												sharing your data.
											</span>
										</li>
									</ul>

									<h6 className="mt-24">
										INFORMATION ON <span className="primecolor">MINORS</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												We do not knowingly collect personal information from
												anyone under 18 years of age.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												If you are a minor, please do not use or submit any
												information to the website.
											</span>
										</li>
									</ul>

									<h6 className="mt-24">
										CORRECTIONS AND <span className="primecolor">UPDATES</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												To update or modify your personal data, contact us at:
												<strong> 📧 info@udemandme.com</strong>
											</span>
										</li>
									</ul>

									<h6 className="mt-24">
										MODIFICATIONS TO THIS{" "}
										<span className="primecolor">PRIVACY POLICY</span>
									</h6>
									<ul className="mt-20">
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												Our policies may be updated occasionally. We encourage
												users to check this section regularly.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												Updates become effective from the date they are posted.
											</span>
										</li>
										<li className="text-gray-400 mb-14 flex-align gap-14">
											<span className="text-md text-gray-900">
												If you have suggestions, feel free to email or WhatsApp
												us your feedback.
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default PrivacyPolicy;
